import React, { useEffect, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { cn } from "helper/Utils";
import { isImageUrl } from "helper/Functions";
import { GAMES_CATEGORY_NAV } from "routes/APP_ROUTES";

export const GamesCategoriesSlider = ({ selectedCategory, setSelectedCategory }) => {
  const navRef = useRef(null);
  // const [selectedCategory, setSelectedCategory] = useState(null);
  const location = useLocation();

  const scrollLeft = () => {
    if (navRef.current) {
      navRef.current.scrollBy({ left: -600, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (navRef.current) {
      navRef.current.scrollBy({ left: 600, behavior: "smooth" });
    }
  };

  const gameCategoryNavItems = GAMES_CATEGORY_NAV();

  const isLiveCasino = location.pathname.startsWith("/live-casino");
  useEffect(() => {
    const currentCategories = isLiveCasino ? gameCategoryNavItems.LIVE_CASINO : gameCategoryNavItems.CASINO;
    const activeCategory = currentCategories[0].category;
    setSelectedCategory(activeCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentCategories = location.pathname.startsWith("/live-casino") ? gameCategoryNavItems.LIVE_CASINO : gameCategoryNavItems.CASINO;

  return (
    <>
      <style jsx="true">
        {`
          .games-category-nav a img {
            filter: invert(30%) sepia(16%) saturate(200%) hue-rotate(180deg) brightness(70%) contrast(100%);
          }
          .games-category-nav a:hover img,
          .games-category-nav a.active img {
            color: rgb(167 31 103);
            filter: invert(34%) sepia(150%) saturate(700%) hue-rotate(286deg) brightness(58%) contrast(130%);
          }
          .games-category-nav a:hover p {
            color: black;
          }
          .games-category-nav a.active i {
            color: rgb(167 31 103);
          }
          .games-category-nav a.active p {
            color: black;
          }

          // @media screen and (max-width: 1580px) {
          //   .games-category-nav a {
          //     flex-direction: column !important;
          //     gap: 0.25rem;
          //   }
          //   .games-category-nav a img {
          //     height: 25px;
          //   }
          // }
        `}
      </style>
      <div className="md:px-2 pl-2 pr-0 relative mt-4">
        <nav
          ref={navRef} // Attach the ref to the nav element
          className="games-category-nav flex gap-[0.5rem] rounded-md overflow-x-auto hide-scrollbar md:mt-1"
        >
          {currentCategories.map((item, index) => {
            return (
              <Link
                key={index}
                to={isLiveCasino ? "/live-casino" + item.path + "/asc" : "/casino" + item.path + "/asc"}
                onClick={() => setSelectedCategory(item)}
                className={cn(
                  "cursor-pointer flex flex-none lg:flex-row flex-col lg:min-w-auto min-w-[70px] items-center gap-[0.25rem] sm:gap-0 lg:gap-5 bg-[#263045] px-3 py-1 border border-[rgb(167,31,103,0.6)] md:rounded-md rounded text-[17px] text-white/60 ",
                  // selectedCategory?.path === item.path ? "active" : "",
                  "hover:bg-[rgb(255,255,255,.9)] hover:text-primary [& p]:hover:text-black hover:border-transparent",
                  "[&.active i]:text-primary [&.active p]:text-black [&.active]:bg-[rgb(255,255,255,.9)] [&.active]:sticky",
                  location.pathname.split("/")[2] === item?.path.slice(1) ? "active" : ""
                )}
                // isActive={() => selectedCategory?.path === item.path}
              >
                {isImageUrl(item.icon) ? (
                  <img className="lg:h-[50px] h-[24px]" src={item.icon} alt={item.label} />
                ) : (
                  <span className="leading-none text-[24px] lg:text-[50px]">{item.icon}</span>
                )}
                <p className="m-0 text-[10px] sm:text-[10px] lg:text-[14px] text-nowrap">{item.label}</p>
              </Link>
            );
          })}
        </nav>
        {currentCategories.length > 13 ? (
          <div className="hidden lg:block">
            <button
              onClick={scrollLeft}
              className="slider-gradiant-arrow arrow-prev absolute left-0 top-1/2 transform -translate-y-1/2 "
              aria-label="Scroll Left"
            >
              <i className="bc-i-small-arrow-left text-[#fffc] text-[11px]"></i>
            </button>
            <button
              onClick={scrollRight}
              className="slider-gradiant-arrow arrow-next absolute right-0 top-1/2 transform -translate-y-1/2  "
              aria-label="Scroll Right"
            >
              <i className="bc-i-small-arrow-right text-[#fffc] text-[11px]"></i>
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
};
